import { render } from "./AddMerchantDialog.vue?vue&type=template&id=62a9a9fb&scoped=true"
import script from "./AddMerchantDialog.vue?vue&type=script&lang=js"
export * from "./AddMerchantDialog.vue?vue&type=script&lang=js"

import "./AddMerchantDialog.vue?vue&type=style&index=0&id=62a9a9fb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a9a9fb"]])

export default __exports__